<template>
  <div>
    <!-- <v-layout wrap justify-start>
      <v-flex xs12 text-left >
        <span style="font-size:22px;font-family: poppinssemibold"
          >Learn about the Reserve</span
        >
      </v-flex>
    </v-layout> -->
    <v-layout wrap justify-center>
      <v-flex xs12 lg11>
        <v-layout wrap justify-space-between py-2>
          <v-flex v-for="(item, i) in navItems" :key="i" px-2>
            <router-link :to="'/learnAboutTheReserve?content=' + item.name">
              <v-btn
                block
                text
                :ripple="false"
                :style="{
                  border:
                    $route.query.content == item.name
                      ? '1px solid #ffe200'
                      : !$route.query.content &&
                        item.name == 'Parambikulam Tiger Reserve'
                      ? '1px solid #ffe200'
                      : 'none',
                }"
              >
                <span
                  style="
                    font-family: poppinssemibold;
                    font-size: 14px;
                    color: #343434;
                    text-transform: none;
                  "
                >
                  {{ item.name }}
                </span>
              </v-btn>
            </router-link>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
    <v-layout wrap justify-center>
      <v-flex xs12>
        <div
          v-if="
            $route.query.content == 'Parambikulam Tiger Reserve' ||
              !$route.query.content
          "
        >
          <ParambikulamTigerReserve />
        </div>
        <div v-if="$route.query.content == 'FDA'">
          <FDA />
        </div>
        <!-- <StoryOfTheReserve
          v-if="$route.query.content == 'Story of the Reserve'"
        /> -->
        <div v-if="$route.query.content == 'Kerala Forest Department'">
          <KeralaForestDepartment />
        </div>
        <div v-if="$route.query.content == 'Organisational Chart'">
          <OrganisationalChart />
        </div>
        <div v-if="$route.query.content == 'Reports'">
          <Reports />
        </div>
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
import ParambikulamTigerReserve from "./parambikulamTigerReserve";
import FDA from "./fda";
// import StoryOfTheReserve from "./storyoftheReserve";
import KeralaForestDepartment from "./keralaForestDepartment";
import OrganisationalChart from "./organisationalChart";
import Reports from "./reports";

export default {
  components: {
    ParambikulamTigerReserve,
    FDA,
    // StoryOfTheReserve,
    KeralaForestDepartment,
    OrganisationalChart,
    Reports,
  },
  data() {
    return {
      navItems: [
        { name: "Parambikulam Tiger Reserve" },
        { name: "FDA" },
        // { name: "Story of the Reserve" },
        { name: "Kerala Forest Department" },
        { name: "Organisational Chart" },
        { name: "Reports" },
      ],
    };
  },
};
</script>
